import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterGeoFenceExist"
    ,pure: false
})
export class FilterGeoFenceExist implements PipeTransform {
    // items:설정목록
    // filter:배송목록
    transform(items:any[],filter:any[]) {
        if(!items || !filter){
            return items;
        }

        return items.filter((conf,idx1) => {
            let isExist = false;
            filter.filter((deli,idx2) => {
                if(conf.geoFenceId === deli.geoFenceId){
                    isExist = true;
                }
            });
            return !isExist;
        });
    }
}